import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "styled-components";
import ApplicationRoutes from "./routes/application-routes";
import { persistor, store } from "./store/store-config";
import GlobalStyle from "./styles/global.styled";
import { DialogProvider } from "./contexts/dialog";

import MAIN_THEME from "./styles/themes/main-theme";
import { PaywallActionProvider } from "./contexts/paywall";
import { TermsOfAccept } from "./components/terms-modal";
import { TourProvider } from "./hooks/user-tour";
import { CommonActionProvider } from "./contexts/common";
import { FilterProvider } from "./contexts/filter";

const App: React.FC = () => {

  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <TourProvider>
          <ThemeProvider theme={MAIN_THEME}>
            <FilterProvider>
              <CommonActionProvider>
                <PaywallActionProvider>
                  <DialogProvider>
                    <GlobalStyle />
                    <ApplicationRoutes />
                    <TermsOfAccept />
                  </DialogProvider>
                </PaywallActionProvider>
              </CommonActionProvider>
            </FilterProvider>
          </ThemeProvider>
        </TourProvider>
      </PersistGate>
    </ReduxProvider>
  );
};

export default App;
